var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showScrollbar),expression:"showScrollbar"}],ref:"track",staticClass:"global-floating-scrollbar",class:{
      'is-active': _vm.isHovered || _vm.isDragging || _vm.isScrolling,
      dragging: _vm.isDragging
    },on:{"pointerdown":_vm.handleTrackPointerDown,"mouseenter":_vm.handleTrackMouseEnter,"mouseleave":_vm.handleTrackMouseLeave}},[_c('div',{ref:"thumb",staticClass:"scrollbar-thumb",style:({
        height: _vm.thumbHeight + 'px',
        transform: 'translateY(' + _vm.thumbTop + 'px)'
      }),on:{"pointerdown":function($event){$event.stopPropagation();return _vm.handleThumbPointerDown.apply(null, arguments)}}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }